import { DealTableCell } from '@crm/entities/deal';
import { formatRuPhone } from '@crm/shared/lib';

import type { TDeal } from '@crm/entities/deal';

type PhoneCellProps = {
    phone: TDeal['phone'];
};

export const PhoneCell = ({ phone }: PhoneCellProps) => (
    <DealTableCell
        isEmpty={!phone}
        className="px-1"
        onClick={(event) => event.stopPropagation()}
    >
        {phone ? formatRuPhone(phone) : null}
    </DealTableCell>
);
